if (!customElements.get('ingredients-wl-popup')) {
  customElements.define(
    'ingredients-wl-popup',
    class IngredientsWlPopup extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.lastOpener = null;
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        if (this.parentElement !== document.body) {
          this.root = this.closest('.ingredients-wl');
          document.body.appendChild(this);
          return;
        }

        this.initialized = true;
        if (!this.root) return;
        this.cards = this.root.querySelectorAll('.ingredients-wl__card');

        this.cards.forEach((card) => {
          card.addEventListener('click', () => this.open(Number(card.dataset.index), card.querySelector('.ingredients-wl__card-open')));
        });

        this.querySelectorAll('.ingredients-wl__close').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });

        this.addEventListener('click', (event) => {
          if (event.target === this || event.target.classList.contains('swiper-wrapper') || event.target.classList.contains('ingredients-wl__slider')) this.close();
        });

        this.root.querySelectorAll('.ingredients-wl__link[href^="#"]').forEach((link) => {
          link.addEventListener('click', (event) => this.onLinkClick(event, link));
        });
      }

      onLinkClick(event, link) {
        const hash = decodeURIComponent(link.getAttribute('href').slice(1));
        if (!hash) return;

        const target = document.getElementById(hash) || document.querySelector(`[id$="${CSS.escape(hash)}"]`);
        if (!target) return;

        event.preventDefault();

        if (target.tagName === 'BUTTON' || target.getAttribute('role') === 'button') {
          target.click();
          return;
        }

        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      initSwiper() {
        if (this.swiper || typeof Swiper === 'undefined') return;

        this.swiper = new Swiper(this.querySelector('.ingredients-wl__slider'), {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 16,
          allowTouchMove: true,
          slideToClickedSlide: true
        });
      }

      open(index, opener) {
        this.lastOpener = opener;
        this.setAttribute('open', '');
        this.initSwiper();

        if (this.swiper) {
          this.swiper.update();
          this.swiper.slideTo(index, 0);
        }

        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.modalToggle, { display: false });
        if (typeof lockBodyScroll === 'function') lockBodyScroll();
        document.addEventListener('keydown', this.onKeydown);

        const activeClose = this.querySelectorAll('.ingredients-wl__close')[index];
        if (activeClose) activeClose.focus({ preventScroll: true });
      }

      close() {
        if (!this.hasAttribute('open')) return;

        this.removeAttribute('open');
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.modalToggle, { display: true });
        if (typeof unlockBodyScroll === 'function') unlockBodyScroll();
        document.removeEventListener('keydown', this.onKeydown);

        if (this.lastOpener) this.lastOpener.focus({ preventScroll: true });
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.close();
      }
    }
  );
}
